import { CommonModule } from '@angular/common';
import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import EmblaCarousel, { EmblaCarouselType } from 'embla-carousel';
import { courses } from '../../../providers/static-data';



@Component({
  selector: 'app-teacher-course-play-list',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './teacher-course-play-list.component.html',
  styleUrl: './teacher-course-play-list.component.css'
})
export class TeacherCoursePlayListComponent {
  @ViewChild('embla', { static: true }) emblaRef!: ElementRef<HTMLElement>;
  embla!: EmblaCarouselType;
  selectedIndex = 0;
  data = courses;

  ngAfterViewInit(): void {
    this.embla = EmblaCarousel(this.emblaRef.nativeElement, {
      loop: false,
      align: 'center',
      dragFree: false,
      active: true,
      startIndex: 0,

    });

    this.embla.on('select', () => {
      this.selectedIndex = this.embla.selectedScrollSnap();
    });

    this.selectedIndex = this.embla.selectedScrollSnap();
  }

  

  scrollPrev() {
    if(this.selectedIndex > 0) {
      this.selectedIndex--;
    }
    // this.embla.scrollPrev();
    this.embla.scrollTo(this.selectedIndex);
  }

  scrollNext() {
    if(this.selectedIndex < this.data.length - 1) {
      this.selectedIndex++;
    }
    // this.embla.scrollNext();
    this.embla.scrollTo(this.selectedIndex);
  }
  
  scrollTo(index: number): void {
    this.embla.scrollTo(index);
    this.selectedIndex = index;
  }
}
